import React, { useCallback, useState } from 'react';

import './movements.scss';
import moment from 'moment';
import { Button } from 'src/components/Button/Button';
import { AssignmentStatus, ProposedTrip } from 'src/common/types';
import {
  acceptMovements,
  rejectMovements,
  setAllMovementsClaimed,
  setAllMovementsRejected,
} from '../store/movementStore';
import { useDispatch, useSelector } from 'react-redux';
import { getDriverInfo } from 'src/features/profile/store';
import { get } from 'lodash';

interface ClaimMovementProps {
  movements: ProposedTrip[];
  day: string;
}

export const AcceptAllAssigned: React.FC<ClaimMovementProps> = ({ movements, day }) => {
  const dispatch = useDispatch();
  const driverInfo = useSelector(getDriverInfo);
  const [disabled, setDisabled] = useState(false);
  const getProposedEditIds = useCallback(
    () => movements.filter(m => !m.claimed && !m.rejected).map(m => m.movementAssignment.editId),
    [movements],
  );

  const getProposedMovementIds = useCallback(
    () =>
      movements.filter(m => !m.claimed && !m.rejected).map(m => m.movementAssignment.movementId),
    [movements],
  );

  const handleAcceptAll = () => {
    const editIds = getProposedEditIds();
    if (editIds.length === 0) {
      setDisabled(true);
      return;
    }
    dispatch(
      acceptMovements({
        employeeId: driverInfo.employeeId,
        editIds,
      }),
    );

    dispatch(
      setAllMovementsClaimed({
        status: AssignmentStatus.PROPOSED,
        movementIds: getProposedMovementIds(),
      }),
    );
    setDisabled(true);
  };

  const handleRejectAll = () => {
    const editIds = getProposedEditIds();
    if (editIds.length === 0) {
      setDisabled(true);
      return;
    }
    dispatch(
      rejectMovements({
        employeeId: driverInfo.employeeId,
        editIds,
      }),
    );
    dispatch(
      setAllMovementsRejected({
        status: AssignmentStatus.PROPOSED,
        movementIds: getProposedMovementIds(),
      }),
    );
    setDisabled(true);
  };
  return (
    <>
      <div className="movements-claim-all">
        <div className="claim-all-time">{moment(day).format('dddd MMMM D, YYYY')}</div>
        <div style={{ display: 'flex', justifyContent: 'right', gap: '0.3em' }}>
          <Button
            className="movement-button-all-not-mine"
            title={'Reject all'}
            onClick={handleRejectAll}
            disabled={disabled}
          />
          <Button
            className="movement-button-claim-all "
            title={'Accept all'}
            onClick={handleAcceptAll}
            disabled={disabled}
          />
        </div>
      </div>
    </>
  );
};
